import {
  deleteUserBillingAddressState,
  updateUserBillingAddressState
} from "@app/modules/account/state/user-billing-address";

import type { Middleware } from "@reduxjs/toolkit";

import {
  deleteBillingAddressClicked,
  billingAddressDeleted,
  updateEmailAddressClicked,
  billingAddressUpdated,
  failedUpdateUser,
  userUpdated
} from "./events/settings";
import { openModal } from "../state/modals";
import { updateUser, updateUserError } from "../state/user";

const PROMPT_PASSWORD_MODAL = "prompt_password";
const DELETE_BILLING_ADDRESS_MODAL = "delete_billing_address";

export const settingsTrackingMiddleware: Middleware = () => next => action => {
  const isPromptPasswordModal = () =>
    action.payload && action.payload.type === PROMPT_PASSWORD_MODAL;
  const isDeleteAddressModal = () =>
    action.payload && action.payload.type === DELETE_BILLING_ADDRESS_MODAL;

  // In order to reduce State resolution time, tracking is delayed until next tick
  setTimeout(() => {
    switch (action.type) {
      case updateUser.type:
        userUpdated();
        break;
      case deleteUserBillingAddressState.type:
        billingAddressDeleted();
        break;
      case updateUserBillingAddressState.type:
        billingAddressUpdated();
        break;
      case openModal.type:
        isPromptPasswordModal() && updateEmailAddressClicked();
        isDeleteAddressModal() && deleteBillingAddressClicked();
        break;
      case updateUserError.type:
        failedUpdateUser(action.payload);
    }
  }, 0);

  return next(action);
};
